export const remToPixel = rem => {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  ); /* get root font size */
  return rem * rootFontSize; /* return rem to pixel value */
};

export const pixelToRem = px => {
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  ); /* get root font size */

  return px / rootFontSize;
};
